import { createSelector } from "reselect";

const getSecurity = state => state.get("securityReducer");

export const selectUser = createSelector([getSecurity], security => {
  return security.get("userInfo").toJS();
});
